import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RuiCheckbox } from "../checkbox";
import "./table.script";
export function RuiTableHeader({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "rowgroup",
    class: cx("rui-table__header", className),
    children: /* @__PURE__ */jsx("div", {
      class: "rui-table__row",
      role: "row",
      children
    })
  });
}
export function RuiTableBody({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "rowgroup",
    class: cx("rui-table__body", className),
    children
  });
}
export function RuiTableFooter({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "rowgroup",
    class: cx("rui-table__footer", className),
    children: /* @__PURE__ */jsx("div", {
      class: "rui-table__row",
      role: "row",
      children
    })
  });
}
export function RuiTableColumn({
  id,
  allowsSorting = false,
  isRowHeader = false,
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "columnheader",
    "data-table-column": id,
    "data-table-row-header": isRowHeader ? "" : void 0,
    class: cx("rui-table__column", className),
    children: allowsSorting ? /* @__PURE__ */jsxs("button", {
      type: "button",
      "data-table-sort": id,
      class: "rui-table__sort",
      children: [/* @__PURE__ */jsx("span", {
        children
      }), /* @__PURE__ */jsx("span", {
        class: "rui-table__sort-indicator",
        "aria-hidden": "true"
      })]
    }) : children
  });
}
export function RuiTableRow({
  id,
  disabled,
  actionable,
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: "row",
    "data-table-row": id,
    "data-table-actionable": actionable ? "" : void 0,
    "aria-disabled": disabled ? "true" : void 0,
    class: cx("rui-table__row", className),
    children
  });
}
export function RuiTableCell({
  isRowHeader = false,
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: isRowHeader ? "rowheader" : "gridcell",
    "data-table-cell": true,
    tabindex: -1,
    class: cx("rui-table__cell", className),
    children
  });
}
export function RuiTableSelectionCell({
  scope,
  label,
  class: className,
  ...props
}) {
  const all = scope === "all";
  return /* @__PURE__ */jsx("div", {
    ...props,
    role: all ? "columnheader" : "gridcell",
    "data-table-cell": true,
    "data-table-selection-cell": scope,
    class: cx("rui-table__selection-cell", className),
    children: /* @__PURE__ */jsx(RuiCheckbox, {
      "data-table-select-all": all ? "" : void 0,
      "data-table-select-row": all ? void 0 : "",
      children: /* @__PURE__ */jsx("span", {
        class: "sr-only",
        children: label ?? (all ? "Select all rows" : "Select row")
      })
    })
  });
}
export function RuiTableEmptyState({
  colSpan,
  children,
  class: className,
  ...props
}) {
  const resolvedColSpan = Math.max(1, Math.floor(colSpan));
  return /* @__PURE__ */jsxs("div", {
    role: "row",
    class: "rui-table__row rui-table__row--empty",
    children: [/* @__PURE__ */jsx("div", {
      ...props,
      role: "gridcell",
      "aria-colspan": resolvedColSpan,
      class: cx("rui-table__empty-state", className),
      children: /* @__PURE__ */jsx("span", {
        class: "rui-table__empty-state-message",
        children
      })
    }), Array.from({
      length: resolvedColSpan - 1
    }, (_, index) => /* @__PURE__ */jsx("div", {
      "aria-hidden": "true",
      class: "rui-table__empty-state-spacer"
    }, index))]
  });
}
export function RuiTable({
  children,
  label,
  ariaBusy,
  selectionMode,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-table", {
    ...props,
    label,
    ariaBusy,
    selectionMode,
    children: /* @__PURE__ */jsx("div", {
      class: "rui-table",
      role: "grid",
      "aria-label": label || void 0,
      "aria-busy": ariaBusy === "true" ? "true" : void 0,
      "aria-multiselectable": selectionMode === "multiple" ? "true" : void 0,
      children
    })
  });
}